import { SearchParam } from "@hooks/useSearchParam";
import { getStoredAuthToken } from "@util/auth";
import { META_MANAGE_URL } from "@util/settings";
import { getViewAsId } from "@util/viewAs";
import axios, { Method } from "axios";

class MetaManageClient {
  constructor(private readonly baseUrl: string) {}

  get headers() {
    const viewAsIds = getViewAsId();
    const viewAsTeamId = viewAsIds?.[SearchParam.ViewAsTeam];
    const token = getStoredAuthToken();

    return {
      authorization: token ? `Bearer ${token}` : "",
      // Meta manage only supports view_as_team
      ...(viewAsTeamId ? { team: viewAsTeamId } : {}),
    };
  }

  async call<ResponseData>(
    method: Method,
    endpoint: string,
    params?: unknown,
  ): Promise<ResponseData> {
    const response = await axios.request<{ data: ResponseData }>({
      method,
      url: `${this.baseUrl}${endpoint}`,
      headers: this.headers,
      data: params,
    });
    return response.data.data;
  }
}

export const metaManageClient = new MetaManageClient(META_MANAGE_URL);
